var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap -mb-4"},_vm._l((_vm.data),function(value,prop){return _c('div',{key:prop,staticClass:"mb-4 md:mr-8 w-full md:w-36"},[_c('div',{staticClass:"mb-2 w-full md:w-36 h-36 dark:bg-gray-700",style:({
          boxShadow: value
        })}),_c('CanvasBlockLabel',{attrs:{"label":`${_vm.removeDefaultSuffix(`shadow-${prop}`)}`,"value":value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }